export const emailProviders = {
  GMAIL: 'gmail',
  YAHOO: 'yahoo',
  OUTLOOK: 'outlook',
  ICLOUD: 'icloud',
};

export const emailAddresses = {
  [emailProviders.GMAIL]: ['@gmail', '@google', '@googlemail'],
  [emailProviders.YAHOO]: ['@yahoo', '@rocketmail'],
  [emailProviders.OUTLOOK]: ['@hotmail', '@outlook', '@live', '@msn'],
  [emailProviders.ICLOUD]: ['@icloud', '@me', '@mac'],
};
